// test995
(995 && 0);
